import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import DCardHeader from './components/DCardHeader';
import DCardBody from './components/DCardBody';
import DCardFooter from './components/DCardFooter';
function DCard({ className, style, children, dataAttributes, }) {
    return (_jsx("div", Object.assign({ style: style, className: classNames('card', className) }, dataAttributes, { children: children })));
}
export default Object.assign(DCard, {
    Header: DCardHeader,
    Body: DCardBody,
    Footer: DCardFooter,
});
//# sourceMappingURL=DCard.js.map